import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .ClientAnalyticsChart {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @include respond-to(sm) {
      gap: 16px;
    }

    .BaseSelectField {
      margin-bottom: 0;
    }

    &__chart {
      background-color: #fff;
      padding: 16px;
      border-radius: 4px;
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    .ClientAnalyticsChart {
      &__chart {
        background-color: ${colors.white.hex};
        border-radius: ${border.radius};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
